import { Fragment, useCallback, useEffect, useState } from 'react';
import { Stack, Button, Box } from '@mui/material';
import Loading from '../../common/Loading.component';
import { useSelector } from 'react-redux';
import Alert from '../../common/Alert.component';
import { fetchAPI } from '../../../api/request';
import { API as departments } from '../../../module/departments/api';
import _ from 'lodash';
import { Form } from '../../form/Form';
import { useParams } from 'react-router';
import { API as operations } from '../../../module/operations/api';
import { API as me } from '../../../module/me/api';
import { API as logbook } from '../../../module/logbook/api';
import DrawerComponent from '../../common/Drawer.component';

const STATUS_SEND_LOGBOOK = 'PICKUP SUPPLIER';

const ModalLogbook = ({
  children,
  conf,
  setSuccess = () => {},
  disabled,
  productsList,
  setChecked = () => {},
  operationType = STATUS_SEND_LOGBOOK,
  module: { code },
  label = 'Send to Logbook',
  endIcon,
}) => {
  const { id_operation } = useParams();
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [successAdd, setSuccessAdd] = useState(false);
  const [idDepartment, setIdDepartment] = useState(null);
  const [error, setError] = useState(null);
  const [yacht, setYacht] = useState(false);
  const [delivery_yacht, setDeliveryYacht] = useState(false);
  const [user, setUser] = useState(null);
  const { fields, schema, defaultValues } = conf;

  const onError = useCallback((error) => {
    setError(error);
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess((prev) => !prev);
    setSuccessAdd(true);
    setLoading(false);
    setChecked(null);
    // eslint-disable-next-line
  }, [setLoading, setSuccessAdd]);

  const onSubmit = useCallback(
    (values) => {
      setError(null);

      if (!_.isEmpty(productsList)) {
        if (values?.id_supplier?.id_logbook) {
          const id = values?.id_supplier?.id_logbook;
          const dataForm = {
            id_list_items: _.concat(
              productsList,
              values?.id_supplier?.id_items
            ),
          };
          fetchAPI(
            logbook.updateFromItemsList,
            { id },
            '',
            { ...dataForm },
            jwt
          )
            .then(onSuccess)
            .catch(onError);
        } else {
          setSuccessAdd(false);
          setLoading(true);
          // setSuccess(false);
          const dataForm = {
            ...values,
            id_list_items: productsList,
            id_operator: user?.id,
            id_department: idDepartment,
            operation_type: operationType,
            id_yacht: yacht,
            id_delivery_yacht: delivery_yacht,
          };
          fetchAPI(logbook.createFromItemsList, {}, '', { ...dataForm }, jwt)
            .then(onSuccess)
            .catch(onError);
        }
      } else {
        onError({ message: 'Select at least one product to send to Logbook.' });
      }
    },
    // eslint-disable-next-line
    [
      setLoading,
      jwt,
      onError,
      onSuccess,
      idDepartment,
      yacht,
      user,
      productsList,
      operationType,
    ]
  );

  useEffect(() => {
    fetchAPI(departments.select, { code }, '', null, jwt)
      .then((response) => {
        setIdDepartment(_.head(response)?.id);
      })
      .catch(onError);
    // eslint-disable-next-line
  }, [code]);

  useEffect(() => {
    fetchAPI(me.me, {}, '', null, jwt)
      .then((response) => {
        setUser(response?.id_users_nautica);
      })
      .catch(onError);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAPI(operations.operation, { id: id_operation }, '', null, jwt)
      .then((response) => {
        setYacht(response?.data?.attributes?.id_yacht?.data?.id);
        setDeliveryYacht(response?.data?.attributes?.id_delivery_note?.data?.attributes?.id_logbook?.data?.id);
      })
      .catch(onError);
    //eslint-disable-next-line
  }, [id_operation, jwt]);

  return (
    <Fragment>
      {loading && <Loading />}
      {successAdd && <Alert severity='success'>{'Success!!'}</Alert>}
      {error && (
        <Alert severity='error'>
          {error?.message ? error.message : 'An error has occurred'}
        </Alert>
      )}

      <DrawerComponent
        button={
          <Button variant='contained' disabled={disabled} endIcon={endIcon}>
            {label}
          </Button>
        }
        disabled={disabled}
      >
        <Stack
          spacing={2}
          justifyContent='center'
          alignItems='center'
          width={1}
        >
          <Form
            fields={fields}
            schema={schema}
            defaultValues={defaultValues}
            onSubmit={onSubmit}
          >
            {children}

            <Box display='flex' justifyContent='right' alignItems={'center'}>
              <Button
                type='submit'
                variant='contained'
                disabled={successAdd}
                autoFocus
              >
                Confirm
              </Button>
            </Box>
          </Form>

          {children}
        </Stack>
      </DrawerComponent>
    </Fragment>
  );
};

export default ModalLogbook;
